module.exports = "<hybse-admin-create-templates [actionType]=\"'edit'\">\n\n</hybse-admin-create-templates>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/mail-templates/update-templates/update-templates.component.html
// module id = ../../../../../src/app/components/pages/mail-templates/update-templates/update-templates.component.html
// module chunks = main